import { render, staticRenderFns } from "./DeleteFilterView.vue?vue&type=template&id=0bdabab2"
import script from "./DeleteFilterView.vue?vue&type=script&lang=ts"
export * from "./DeleteFilterView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports